export default __webpack_public_path__ + "/dist/images/product-icon.154e8aec7e15a7eaeae1b46408b7061f.svg";